// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from 'react';
import { StatusComponent, CompletedStatusComponent } from './table-select-filter-components';
import { Link, Box } from '@cloudscape-design/components';
import { createTableSortLabelFn } from '../../i18n-strings';
import { parseAiRecommendationPercentageScore } from '../../common/utility';

const rawColumns = [
  {
    id: 'standard',
    header: 'Standard',
    cell: item => item.indicator.standard.title,
    sortingField: 'standard',
  },
  {
    id: 'indicator',
    header: 'Indicator',
    cell: item => <Link href={`/indicator-submission/${item.id}`}>{item.indicator.name}</Link>,
    sortingField: 'indicator',
  },
  {
    id: 'created',
    header: 'Created Date',
    cell: item => item.created,
    sortingField: 'created',
  },
  {
    id: 'is_complete',
    header: 'Status',
    cell: item => <CompletedStatusComponent status={item.is_complete} />,
    sortingField: 'is_complete',
  },
  {
    id: 'latest_score',
    header: 'AI Score',
    cell: item => item.latest_score ? `${parseAiRecommendationPercentageScore(item.latest_score)}%` : '-',
    sortingField: 'latest_score',
  },
  
];

export const COLUMN_DEFINITIONS = rawColumns.map(column => ({ ...column, ariaLabel: createTableSortLabelFn(column) }));

export const SEARCHABLE_COLUMNS = ['standard', 'indicator', 'created', 'agent_status', 'reviewer_status', 'text'];

export const CONTENT_DISPLAY_OPTIONS = [
  { id: 'standard', label: 'Standard', alwaysVisible: true },
  { id: 'indicator', label: 'Indicator', alwaysVisible: true },
  { id: 'created', label: 'Created Date', alwaysVisible: true },
  { id: 'agent_status', label: 'AI Status', alwaysVisible: true },
  // { id: 'reviewer_status', label: 'Reviewer Status', alwaysVisible: true },
  { id: 'text', label: 'AI Notes', alwaysVisible: true }
];

export const PAGE_SIZE_OPTIONS = [
  { value: 10, label: '10 Indicators' },
  { value: 30, label: '30 Indicators' },
  { value: 50, label: '50 Indicators' }
];